const SPEC_CATEGORIES = {
  base: "",
  design: "設計",
  manufacture: "製造",
  mount: "実装",
  designRequest: "設計リクエスト",
  material: "基材",
  designCriteria: "設計基準",
  resistPrinting: "レジスト印刷",
  coverlay: "カバーレイ",
  silkPrinting: "シルク印刷",
  finishing: "仕上げ",
  reinforcementPlate: "補強板",
  imposition: "面付け情報",
  specialProcessing: "特殊加工",
  standard: "規格",
  inspection: "検査",
  dataFormat: "データ形式など",
  factory: "工場指定",
  specialDesignSpec: "特殊設計仕様",
} as const

export default SPEC_CATEGORIES
